module.exports = __webpack_public_path__ + "media/SilverMiniPartnerBadge.static.38bce44868a8bcf63666843ec7d47f6f.svg";